import React,{useRef,useState,useEffect,useContext} from 'react'
import axios from 'axios'
import 'bootstrap/dist/css/bootstrap.min.css'
import {Alert,Container,Row,Col,Form,Button,Navbar,NavDropdown,Nav,Table,Modal,Card} from 'react-bootstrap'
import logo from './logo.png'
import dkgr from './Dekagro.jpg'

export default function App() {
const apiUrl='https://api.helexpo.gr/agroticaregistrationapi/api/'
//const apiUrl='http://localhost:3009/agroticaregistrationapi/api/'

  const [countries,setCountries]=useState([])
  const [regObj,setRegObj]=useState({})
  const [isRegistered,setIsRegistered]=useState(false)
  const [isLoading,setIsLoading]=useState(false)
  const [gdprAnswer1,setGdprAnswer1]=useState(false)
  const [gdprAnswer2,setGdprAnswer2]=useState(1)
  const [barcode,setBarCode]=useState('')
  const [mailSent,setMailSent]=useState(0)

  const PName=useRef('')
  const Company=useRef('')
  const Job=useRef('')
  const Email=useRef('')
  const City=useRef('')
  const Country=useRef('')
  const CompanyActivity=useRef('')
  const Telephone=useRef('')
  const County=useRef('')




  useEffect(()=>{
    axios.get(apiUrl+'countries').then(res=>{
      setCountries(res.data)
    })
  },[])


  const countriesList=countries.map(item=>{
    return(
      <option selected={item.IsDefault===1 ? true : false} value={item.CountryName}>{item.CountryNameEng} // {item.CountryName}</option>
    )
  })


  const register=(e)=>{
    e.preventDefault()
    setIsLoading(true)
    const xregObj={
      PName:PName.current.value,
      Company:Company.current.value,
      Job:Job.current.value,
      Email:Email.current.value,
      City:City.current.value,
      Country:Country.current.value,
      CompanyActivity:CompanyActivity.current.value,
      Telephone:Telephone.current.value,
      County:'',
      ExCode:'02_2026',
      gdprAnswer1,
      gdprAnswer2,
      token:'hiewf8w7efyhiwehf872398423nddabsdvadytdqw789ey3eeiwqe00231487294'      
    }

    axios.post(apiUrl+'register',xregObj).then(res=>{
      console.log(res.data)
      if (res.data.err==0){
        setRegObj(xregObj)
        setIsRegistered(true)
        setBarCode(res.data.uuidBC)
        setMailSent(res.data.mailSent)
        setIsLoading(false)
      }else{
        alert("Η ΑΠΟΘΚΕΥΣΗ ΔΕΝ ΕΓΙΝΕ, παρακαλούμε προσπαθήστε ξανά")
      }
    })



  }



  return (
    <Container>

      
      <Card>
        <Card.Img variant="top" src={logo} />
        <Card.Body>
          <Card.Title>AGROTICA 2026 // Εγγραφή Επισκεπτών // Visitors' Registration</Card.Title>
          <p align="center">
          <hr/>
          <a href="https://www.dekagro.gr" target="_blank">
          <img src={dkgr} width="250px" style={{borderWidth:'2px',borderColor:'gray',borderStyle:'solid',padding:'10px'}}/>
          </a>
          <hr/>   
          </p>



          {isLoading && 
          <Alert variant="warning">Loading, please wait....</Alert>
          
          }


          {!isRegistered && !isLoading &&
          <Form onSubmit={register}>
          <Form.Group className="mb-3">
            <Form.Select required ref={Country}>
              <option value=''>[ΕΠΙΛΕΞΤΕ ΧΩΡΑ // SELECT COUNTRY]</option>
              {countriesList}
            </Form.Select>
          </Form.Group>


          <Form.Group className="mb-3">
              <Form.Label>Ονοματεπώνυμο // Full Name</Form.Label>
              <Form.Control type="text" required ref={PName}/>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Εταιρία // Company</Form.Label>
              <Form.Control type="text" required ref={Company}/>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Αντικείμενο Εταιρίας // Company Activity</Form.Label>
              <Form.Control type="text" required ref={CompanyActivity}/>
            </Form.Group>


            <Form.Group className="mb-3">
              <Form.Label>Θέση στη Εταιρία // Job Description</Form.Label>
              <Form.Control type="text" required ref={Job}/>
            </Form.Group>



            <Form.Group className="mb-3">
              <Form.Label>Πόλη // City</Form.Label>
              <Form.Control type="text" required ref={City}/>
            </Form.Group>
{/* 
            <Form.Group className="mb-3">
              <Form.Label>Νομός // Region</Form.Label>
              <Form.Control type="text" required ref={County}/>
            </Form.Group> */}


            <Form.Group className="mb-3">
              <Form.Label>Email Address</Form.Label>
              <Form.Control type="email" required ref={Email}/>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Τηλέφωνο // Telephone</Form.Label>
              <Form.Control type="text" ref={Telephone}/>
            </Form.Group>



            <div style={{overflow:'auto',backgroundColor:'#fff',marginBottom:'20px',marginTop:'20px',fontSize:'12px'}}>
            <br/><br/>
            <b>ΣΗΜΑΝΤΙΚΗ ΕΝΗΜΕΡΩΣΗ ΣΧΕΤΙΚΑ ΜΕ ΤΑ ΠΡΟΣΩΠΙΚΑ ΣΑΣ ΔΕΔΟΜΕΝΑ</b><br/><br/>
            Η ΔΕΘ-HELEXPO Α.Ε. λαμβάνει τα δεδομένα σας τα οποία φυλάσσονται σε
            (ηλεκτρονικό ή/και φυσικό) αρχείο υπ’ ευθύνη της, τηρώντας όλα τα
            κατάλληλα μέτρα ασφάλειας και σύμφωνα με την Πολιτική μας για την
            Προστασία Προσωπικών Δεδομένων στον ιστότοπό
            μας 
            <a href="https://helexpo.gr/wp-content/uploads/2026/01/Privacy_Policy.pdf" target="_blank">
            https://helexpo.gr/wp-content/uploads/2026/01/Privacy_Policy.pdf
            </a>
            . (email επικοινωνίας
            dpo@helexpo.gr)<br/><br/>
            Με τη συμπλήρωση των στοιχείων σας για αποστολή πρόσκλησης αναγνωρίζετε και αποδέχεστε
            ότι, στα πλαίσια διεξαγωγής της έκθεσης ενδέχεται να φωτογραφηθείτε, βιντεοσκοπηθείτε ή / και
            ηχογραφηθείτε.<br/><br/>
            Επίσης τεκμαίρεται η συγκατάθεσή σας για την με οποιονδήποτε τρόπο χρήση των ως άνω
            εικόνων, φωτογραφιών ή / και ηχογραφήσεων σας από την ΔΕΘ HELEXPO AE και τους συνεργάτες
            της, παραιτούμενος από κάθε αξίωσή σας από τη χρήση του ως άνω υλικού, η οποία περιλαμβάνει
            ενδεικτικά τη δημοσίευση, αναμετάδοση και χρήση του αποκλειστικά για την προώθηση,
            διαφήμιση, προβολή και παρουσίαση της Έκθεσης.<br/><br/>

            <b>IMPORTANT INFORMATION CONCERNING YOUR PERSONAL DATA</b><br/><br/>
            TIF HELEXPO receives your data which are kept in an (electronic and/or
            physical) archive under its responsibility, taking all the appropriate security
            measures according our Personal Data Protection Policy on our website,
            <a href="https://helexpo.gr/wp-content/uploads/2026/01/Privacy_Policy_eng.pdf" target="_blank">
            https://helexpo.gr/wp-content/uploads/2026/01/Privacy_Policy_eng.pdf
            </a>            
            
            
            . (contact email dpo@helexpo,gr)
            <br/><br/>
            By submitting your details in order to receive the invitation to the trade show, you acknowledge and
            agree to the fact that during your visit to exhibition you may be photographed, videotaped and/or
            recorded by TIF HELEXPO SA and its employees.<br/><br/>
            By submitting your details, it is presumed that you agree to the use of said images, photos and/or
            recordings in any way by TIF HELEXPO SA and its employees, waivering all claims from the use of all
            the above-mentioned material, which may include, but is not limited to the publication, broadcast or
            any other use only for the promotion of the trade show.
            <br/><br/>


            <Alert variant="warning">
            Επιθυμείτε να ενημερώνεστε ηλεκτρονικά ή μέσω ταχυδρομείου, για τη συγκεκριμένη έκθεση, στις διευθύνσεις που δηλώσατε;
            <br/><br/>
            Would you like to receive emails or regular mail, for the specific exhibition, to the above-mentioned addresses?

            <br/><br/>
              <Form.Group className="mb-3">
              <Form.Select required onChange={(e)=>setGdprAnswer1(e.target.value)}>
                <option value=''>[ΠΑΡΑΚΑΛΟΥΜΕ ΑΠΑΝΤΗΣΤΕ // PLEASE ANSWER]</option>
                <option value="1">NAI // YES</option>
                <option value="0">OXI // NO</option>
              </Form.Select>
              </Form.Group>
            </Alert>
            
 



            </div>


            <p align="right">
            <Button disabled={!(gdprAnswer1 && gdprAnswer2)} variant="dark" type="submit" style={{width:'250px',height:'50px'}}>
              Εγγραφή // Register
            </Button>
            </p>
          </Form>
          }  

          {isRegistered && !isLoading &&
          
          <Alert variant="success">
          <Alert.Heading>Η Εγγραφή σας έγινε με επιτυχία!</Alert.Heading>
          <p>
            {mailSent==1 &&
              <>
              Θα παραλάβετε ένα email από το <b>helexpo.services@gmail.com</b> στη διεύθυνση email <b>{regObj.Email}</b><br/> και θέμα <b>AGROTICA 2026 // Registration // Παραλαβή Κάρτας Εισόδου</b>.
              <br/><br/>
              Εκεί θα είναι διαθέσιμος ο σύνδεσμος (link) από τον οποίο μπορέιτε να παραλάβετε την κάρτα εισόδου (badge).<br/><br/>

             <i> Εάν δεν φανεί ότι παραλάβατε το email παρακαλούμε να κάνετε έλεγχο και στο spam folder (ανεπιθύμητα) των email σας.</i>
            </>
            }
            {mailSent==0 && 
            <>
            <br/>
            <hr/>

            <b>Την κάρτα εισόδου μπορείτε να την παραλάβετε και απευθείας από &nbsp;
            
            <a href={`https://api.helexpo.gr/agrotica2026/visitorbadge/?badge=${barcode}`} target="_blank">
            ΕΔΩ
            </a>
            </b>
            </>
            }
          </p>

          </Alert>           
          
          
          }

        </Card.Body>
      </Card>





      <>
        <br/><br/><br/>
       <br/><br/><br/>
        <div className="footer">
        
        HELEXPO // AGROTICA 2026 // Τμήμα Μηχανογράφησης - 2026
      </div>
    </>
    </Container>
  )
}
